import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Const
import { timeFormat } from '../../const/nuclias/dateFormat';

// Service
import authService from '../../services/Auth.service';
import userService from '../../services/Auth.User.service';

import dayjs from 'dayjs';

const initialState = {
  userApiKeysData: [],
  originalUserApiKeysData: [],
  apiEndpointUrl: '',
  modalGetApiKey: '',
};

const formatApiKeysData = (dataArray = []) => {
  const result = dataArray.map(list => {
    return {
      ...list,
      checked: false,
      lastAccessIpAddress: list.last_access.from.ip || '-',
      lastAccessLocation: `${list.last_access.from.city || '-'} / ${
        list.last_access.from.country || '-'
      }`,
      updatedAt: dayjs(list.updated_at).format(timeFormat.dateAndTimeToMinute),
      createdAt: dayjs(list.created_at).format(timeFormat.dateAndTimeToMinute),
    };
  });
  const sortTableResult = result.sort(function (a, b) {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
  return sortTableResult;
};

export const fetchUserApiKeysData = createAsyncThunk(
  'apiAccess/fetchUserApiKeysData',
  async (userId, thunkAPI) => {
    const response = await userService.getUserApiKeys(userId);

    if (response.error) {
      return thunkAPI.rejectWithValue(response.error);
    }

    const userApiKeysData = response.data;
    return formatApiKeysData(userApiKeysData);
  }
);

export const fetchAuthResources = createAsyncThunk(
  'apiAccess/fetchAuthResources',
  async (_, thunkAPI) => {
    const response = await authService.getAuthResources();

    if (response.error) {
      return thunkAPI.rejectWithValue(response.error);
    }

    const apiEndpointUrl = response.params.webserver.substring(
      0,
      response.params.webserver.length - 1
    );
    return apiEndpointUrl;
  }
);

export const updateUserApiKeysName = createAsyncThunk(
  'apiAccess/updateUserApiKeysName',
  async (param, thunkAPI) => {
    const { userId, keyId, newApiKeyName } = param;

    const response = await userService.updateUserApiKeysName(
      userId,
      keyId,
      newApiKeyName
    );

    if (response.error) {
      return thunkAPI.rejectWithValue(response.error);
    }

    const newUserApiKeysData = response.data;
    return newUserApiKeysData;
  }
);

export const generateUserApiKey = createAsyncThunk(
  'apiAccess/generateUserApiKey',
  async (param, thunkAPI) => {
    const { userId, modalApiKeyName } = param;

    const response = await userService.generateUserApiKey(
      userId,
      modalApiKeyName
    );

    if (response.error) {
      return thunkAPI.rejectWithValue(response.error);
    }

    const tmpData = response.data;
    const modalGetApiKey = tmpData.access_token || '';
    return modalGetApiKey;
  }
);

export const revokeUserApiKey = createAsyncThunk(
  'apiAccess/revokeUserApiKey',
  async (param, thunkAPI) => {
    const { userId, revokeDataArray } = param;

    const response = await userService.revokeUserApiKey(
      userId,
      revokeDataArray
    );

    if (response.error) {
      return thunkAPI.rejectWithValue(response.error);
    }

    return response.data;
  }
);

const apiAccessSlice = createSlice({
  name: 'apiAccess',
  initialState,
  reducers: {
    changeTableCheckbox: (state, action) => {
      state.userApiKeysData = action.payload;
    },
    resetTableData: (state, action) => {
      state.userApiKeysData = action.payload;
    },
  },
  extraReducers: {
    [fetchUserApiKeysData.fulfilled]: (state, action) => {
      state.userApiKeysData = action.payload;
      state.originalUserApiKeysData = action.payload;
    },
    [fetchAuthResources.fulfilled]: (state, action) => {
      state.apiEndpointUrl = action.payload;
    },
    [updateUserApiKeysName.fulfilled]: (state, action) => {
      state.userApiKeysData = action.payload;
    },
    [generateUserApiKey.fulfilled]: (state, action) => {
      state.modalGetApiKey = action.payload;
    },
    [revokeUserApiKey.fulfilled]: (state, action) => {
      state.userApiKeysData = action.payload;
    },
  },
});

export const apiAccessActions = apiAccessSlice.actions;

export default apiAccessSlice;
